export const trListPrice = {
	DE: 'UVP',
	EN: 'List price',
	FR: 'Liste de prix',
};
export const trNew = { DE: 'Neu', EN: 'New', FR: 'Nouveau' };
export const trRare = {
	DE: 'Selten',
	EN: 'Rare',
	FR: 'Rares',
};
export const trDiscount = {
	DE: '${rate}% Rabatt',
	EN: '${rate}% Discount',
	FR: '${rate}% de remise',
};
export const trNewestFirst = {
	DE: 'Neuste zuerst',
	EN: 'Newest first',
	FR: 'le plus récent en premier',
};
export const trInStock = {
	DE: 'Auf Lager',
	EN: 'In stock',
	FR: 'En stock',
};

export const trInStockLimitedAmount = {
	DE: 'Nur noch ${amount} Stück auf Lager',
	EN: 'Only ${amount} in stock left',
	FR: 'Seulement ${amount} en stock',
};

export const trNotInStock = {
	DE: 'Nicht auf Lager',
	EN: 'Not in stock',
	FR: 'Pas en stock',
};
export const trComingSoon = {
	DE: 'Bald verfügbar',
	EN: 'Coming soon',
	FR: 'Bientôt disponible',
};
export const trDeliveryExpected = {
	DE: 'Im Zulauf',
	EN: 'Delivery expected',
	FR: 'Livraison attendue',
};
export const trDeliveryTimeOneRequest = {
	DE: 'Liefertermin auf Anfrage',
	EN: 'Delivery time on request',
	FR: 'Date de livraison sur demande',
};
export const trDeliveryDigital = {
	DE: 'Digitaler Versand',
	EN: 'Digital delivery',
	FR: 'Livraison digitale',
};
export const trReadyForDeliveryNextBusinessDay = {
	DE: 'Versandfertig am nächsten Werktag',
	EN: 'Ready for delivery on the next business day',
	// prettier-ignore
	FR: 'Prêt pour l\'expédition le jour ouvrable suivant',
};
export const trReadyForDeliveryTwoFiveBusinessDays = {
	DE: 'Versandfertig in 2-5 Werktagen',
	EN: 'Ready for delivery 2-5 business days',
	// prettier-ignore
	FR: 'Prêt pour l\'expédition sous 2-5 jours',
};
export const trReadyForDeliverySixTenBusinessDays = {
	DE: 'Versandfertig in 6-10 Werktagen',
	EN: 'Ready for delivery 6-10 business days',
	// prettier-ignore
	FR: 'Prêt pour l\'expédition sous 6-10 jours',
};
export const trAvailableForPreOrder = {
	DE: 'Vorbestellbar',
	EN: 'Available for pre-order',
	FR: 'Disponible en pré-commande',
};
export const trPreOrder = {
	DE: 'Vorbestellbar',
	EN: 'Pre-order',
	FR: 'Précommande',
};
export const trExceptedAvailableFrom = {
	DE: 'Lieferbar ab',
	EN: 'Available from',
	FR: 'Disponible',
};
export const trPreOrderFrom = {
	DE: 'Vorverkauf ab',
	EN: 'Presale from',
	FR: 'Prévente à partir de',
};
export const trProductDetails = {
	DE: 'Produktdetails',
	EN: 'Product Details',
	FR: 'Détails du produit',
};
export const trArticleNumber = {
	DE: 'Artikelnummer',
	EN: 'Article number',
	// prettier-ignore
	FR: 'Numéro d\'article',
};
export const trManufacturer = {
	DE: 'Hersteller',
	EN: 'Manufacturer',
	FR: 'Fabricant',
};
export const trManufacturerPartNumber = {
	DE: 'Herstellernummer',
	EN: 'Manufacturer Part Number',
	FR: 'Numéro du fabricant',
};
export const trEAN = {
	ALL: 'EAN',
};
export const trPackagingDimensions = {
	DE: 'Verpackungsmaße',
	EN: 'Packaging dimensions',
	// prettier-ignore
	FR: 'Dimensions de l\'emballage',
};
export const trWeight = {
	DE: 'Gewicht',
	EN: 'Weight',
	FR: 'Poids',
};
export const trIncludingVatPlusShippingCosts = {
	DE: 'Inkl. MwSt., zzgl. Versandkosten',
	EN: 'Including VAT, plus shipping costs',
	// prettier-ignore
	FR: 'TVA comprise, plus frais d\'expédition',
};
export const trAddToCart = {
	DE: 'In den Warenkorb',
	EN: 'Add to cart',
	FR: 'Ajouter au panier',
};
export const trPreOrderNow = {
	DE: 'Jetzt vorbestellen',
	EN: 'Pre-order now',
	FR: 'Pré-commandez',
};
export const trProductDescription = {
	DE: 'Produktbeschreibung',
	EN: 'Product Description',
	FR: 'Description du produit',
};
export const trThereAreCurrentlyNoProductsAvailableInThisCategory = {
	DE: 'Zur Zeit sind keine Produkte in dieser Kategorie verfügbar.',
	EN: 'There are currently no products available in this category.',
	// prettier-ignore
	FR: 'Il n\'y a actuellement aucun produit disponible dans cette catégorie.',
};
export const trPreviousPrice = {
	DE: 'Regulärer Preis',
	EN: 'Regular Price',
	FR: 'Prix normal',
};

export const trPreviousSinglePrice = {
	DE: 'Regulärer Einzelpreis',
	EN: 'Regular Single Price',
	FR: 'Prix unitaire normal',
};
export const trDiscoverSimilarProducts = {
	DE: 'Ähnliche Produkte finden',
	EN: 'Discover similar products',
	FR: 'Produits similaires',
};
